import React from 'react';

const X = () => {
    return (
        <div>
            <video controls autoPlay 
            src="https://firebasestorage.googleapis.com/v0/b/alif-aisbook.appspot.com/o/video%2FPure%20CSS%20Scroll%20Indicator%20-%20Scroll%20Animation%20Effect.mp4?alt=media&token=ba3eaed7-e8ac-4114-89d0-83a3f5eff357" style={{height:'auto', width:'auto'}}/>
            <video controls autoPlay src="https://firebasestorage.googleapis.com/v0/b/alif-aisbook.appspot.com/o/video%2FPure%20CSS%20Scroll%20Indicator%20-%20Scroll%20Animation%20Effect.mp4?alt=media&token=ba3eaed7-e8ac-4114-89d0-83a3f5eff357" style={{height:'300px', width:'500px'}}/>
            
            </div>
    );
};

export default X;